import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import HeaderMainMenu from '@/domains/menus/components/HeaderMainMenu.vue';
import HeaderMainMenuMobile from '@/domains/menus/components/HeaderMainMenuMobile.vue';
import { useOpenClose, useBreakpoint, useBodyScrollLock } from '~/composables';

interface Props {
  menuTop?: any[];
  menuMain?: any[];
  dark?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    menuTop: { default: () => [] },
    menuMain: { default: () => [] },
    dark: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { menuTop: any[], menuMain: any[], dark: boolean };


const {
  $config: { joinuApp: isJoinuApp },
} = useContext();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const mainMenuWrap = ref<HTMLElement>();
const {
  isOpen: isOpenSearch,
  open: openSearch,
  close: closeSearch,
} = useOpenClose();
const isMenuOpen = ref(false);
const isMobileMenuOpen = ref(false);

useBodyScrollLock(isMobileMenuOpen);

const headerBgColor = computed(() => {
  if (isMenuOpen.value) return 'md:bg-gray-lighten3';
  if (props.dark) return 'md:bg-gray-lighten3';

  return 'md:bg-transparent';
});

const headerTextColor = computed(() => {
  if (isMenuOpen.value) return 'md:text-[#494949]';
  if (props.dark) return 'md:text-slate';

  return 'md:text-white';
});

const toggleMenu = (value: boolean) => {
  isMenuOpen.value = value;
};

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

return { __sfc: true,props, isJoinuApp, isDesktop, mainMenuWrap, isOpenSearch, openSearch, closeSearch, isMenuOpen, isMobileMenuOpen, headerBgColor, headerTextColor, toggleMenu, toggleMobileMenu, HeaderMainMenu, HeaderMainMenuMobile }
}

})